import defaultApolloClient from "./defaultApolloClient";
import teaApolloClient from '@/tea/composables/apollo/teaDefaultApolloClient';
import domain from "@/utils/appDomain";

const apolloClient = domain.isTea ? teaApolloClient: defaultApolloClient;
export default apolloClient;

